<script setup>
defineProps([ 'size', 'type' ])
</script>

<template>
  <svg
    viewBox="0 0 63 69"
    class="icon-toggle"
    :style="{ width: size + 'px', height: size + 'px' }"
    aria-hidden="true"
  >
    <g class="icon-toggle-group">
      <g opacity="0.5">
        <path class="icon-toggle-halo icon-toggle-halo-1" d="M31.4944 15.4701C33.7534 14.0308 36.4463 13.431 39.1026 13.7756C45.0276 14.5948 49 20.4188 49 26.1193C49 36.69 34.5354 45.3194 31.4944 45.3194C28.4534 45.3194 14 36.7125 14 26.1418C14 20.4076 17.9724 14.5836 23.8974 13.7981C26.5476 13.4447 29.2375 14.0367 31.4944 15.4701Z" stroke="#FF4B8C" stroke-linecap="round" stroke-linejoin="round" />
      </g>

      <g opacity="0.2">
        <path class="icon-toggle-halo icon-toggle-halo-2" d="M31.4809 9.78291C34.7389 8.58458 38.2794 8.381 41.6533 9.19799C49.0283 11.118 54 18.5947 54 26.313C54 39.5244 38.093 50.2944 31.5191 50.2944C24.9452 50.2944 9 39.4989 9 26.313C9 18.6201 13.9336 11.1435 21.3086 9.24886C24.6774 8.41558 28.2178 8.60145 31.4809 9.78291Z" stroke="#FF4B8C" stroke-linecap="round" stroke-linejoin="round" />
      </g>

      <g opacity="0.05">
        <path class="icon-toggle-halo icon-toggle-halo-3" d="M31.493 4.01302C35.7673 3.12357 40.2025 3.40708 44.3287 4.8335C53.1176 8.00417 59 17.099 59 26.8196C59 42.6312 42.1176 55.4947 31.493 55.4947C20.8685 55.4947 4 42.6312 4 26.8196C4 17.0851 9.86853 8.00417 18.6713 4.8335C22.7927 3.40688 27.2235 3.12335 31.493 4.01302Z" stroke="#FF4B8C" stroke-linecap="round" stroke-linejoin="round" />
      </g>

      <path
        class="icon-toggle-shape"
        :class="{ [`icon-toggle-${type}`]: true }"
        d="M36.6063 18.4097C40.9963 18.4097 44 22.5409 44 26.3949C43.9538 34.1952 31.6987 40.5908 31.4769 40.5908C31.2551 40.5908 19 34.1952 19 26.3949C19 22.5409 21.9575 18.4097 26.3937 18.4097C27.3632 18.4096 28.3208 18.6223 29.1991 19.0327C30.0774 19.4431 30.8549 20.0412 31.4769 20.7849C32.103 20.0342 32.8878 19.4319 33.7748 19.0211C34.6618 18.6104 35.6288 18.4016 36.6063 18.4097Z"
        fill="#FF4B8C" />
    </g>
  </svg>
</template>
